import { SubscriptionId } from '../../../../objects/subscription-plans';
import { FORM_TEMPLATE_DISPLAY_ORIENTATION, PAGE_FORMATS } from '../constants';
import FormTemplateHistory from './form-template-history.entity';

export default class FormTemplate {
  /**
   * contains the unique identifier for the form
   *
   * @var {string}
   */
  id: string;

  /**
   * contains the name of the form
   *
   * @var {string}
   */
  name: string;

  /**
   * contains the module name for this module belongs to
   *
   * @var {string}
   */
  module: string;

  /**
   * tells if the current form is active or not
   *
   * @var {boolean|undefined}
   */
  isActive?: boolean = false;

  /**
   * contains the list of template history that is uploaded
   *
   * @var {FormTemplateHistory[]}
   */
  histories?: FormTemplateHistory[] = [];

  /**
   * contains the current default form template history
   *
   * @var {FormTemplateHistory}
   */
  history?: FormTemplateHistory;

  /**
   * contains the form creation date
   *
   * @var {string}
   */
  createdAt: string;

  /**
   * contains the form updated date
   *
   * @var {string|undefined}
   */
  updatedAt?: string;

  /**
   * contains the form updated date
   *
   * @var {string|null}
   */
  documentType?: string | null;

  /**
   * Contains the template minimum client subscription requirements
   *
   * @var {SubscriptionId|null}
   */
  minSubscription?: SubscriptionId | null;

  /**
   * For HTML Document templates, contains the HTML data
   *
   * @var {string}
   */
  html_data?: string;

  /**
   * For HTML Document templates, contains the CSS data
   *
   * @var {string}
   */
  css_data?: string;

  /**
   * Tells if the template is a custom user-added one. All user-added templates in Document Templates have a value of true
   *
   * @var {boolean}
   */
  is_custom_template?: boolean;

  /**
   * Tells if the template has an odt template
   *
   * @var {boolean}
   */
  has_odt_template?: boolean;

  /**
   * The display orientation of the template, portrait or landscape. Default is landscape.
   *
   * @var {FORM_TEMPLATE_DISPLAY_ORIENTATION}
   */
  display_orientation?: FORM_TEMPLATE_DISPLAY_ORIENTATION;

  /**
   * The paper size of the document, etc: A4, Letter, etc.
   *
   * @var {PAGE_FORMATS}
   */
  page_format?: PAGE_FORMATS;

  /**
   * Tells that template is HTML or not
   */
  readonly isHTML?: boolean;

  constructor(data: {
    id: string;
    name: string;
    moduleName: string;
    isActive?: boolean;
    histories?: FormTemplateHistory[];
    history?: FormTemplateHistory;
    createdAt: string;
    updatedAt?: string;
    documentType?: string;
    minSubscription?: SubscriptionId;
    isHTML?: boolean;
    html_data?: string;
    css_data?: string;
    is_custom_template?: boolean;
    has_odt_template?: boolean;
    display_orientation?: FORM_TEMPLATE_DISPLAY_ORIENTATION;
    page_format?: PAGE_FORMATS;
  }) {
    this.id = data.id;
    this.name = data.name;
    this.module = data.moduleName;
    this.isActive = data.isActive || false;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt || undefined;
    this.histories = data.histories || [];
    this.history = data.history || null;
    this.documentType = data.documentType || null;
    this.minSubscription = data.minSubscription || null;
    this.isHTML = data.isHTML || false;
    this.html_data = data.html_data || '';
    this.css_data = data.css_data || '';
    this.is_custom_template = data.is_custom_template || false;
    this.has_odt_template = data.has_odt_template || false;
    this.display_orientation = data.display_orientation || 'landscape';
    this.page_format = data.page_format || 'a4';
  }
}
